export default __webpack_public_path__ + "static/media/Number_3_selected_dark.78fbe673.svg";